import { ref, getBlob } from 'firebase/storage'
import { getAppStorage } from '@/firebase/storage-routing'
import { saveAs } from 'file-saver'
import { kGcsArtifactsBucketRef } from '@/constants/constants-gcs'
import { ArtifactVersionRead } from '../schemas'
import { getArtifactVersionGCSPath } from '../utils'

/**
 * Downloads an artifact version from GCS.
 * @param artifactVersion The artifact version to download.
 * @param userId The ID of the user.
 */
export async function downloadArtifactVersion(artifactVersion: ArtifactVersionRead, userId: string) {
  const filePath = getArtifactVersionGCSPath(artifactVersion, userId)
  const storage = getAppStorage({ bucketUrl: kGcsArtifactsBucketRef, legacy_always_cloud: true })
  const storageRef = ref(storage, filePath)
  const blob = await getBlob(storageRef)
  saveAs(blob, `${artifactVersion.name || 'download'}.${artifactVersion.file_extension}`)
}
